import { useMemo } from 'react';
import { useDebounce } from 'src/hooks/useDebounce';
import { SearchResponseItem } from 'src/requests/search';
import { useGeneralSearchQuery } from '../useGeneralSearchQuery';
import { MappedSearchResult, SearchTypeEnum, SortByEnum } from './types';

type GlobalSearchProps = {
  searchTerm: string;
  sortBy?: SortByEnum;
  searchTypes: SearchTypeEnum[];
  isFlat?: boolean;
};
export const useGlobalSearch = ({
  searchTerm,
  sortBy = SortByEnum.LAST_UPDATED,
  searchTypes = [],
  isFlat = false,
}: GlobalSearchProps) => {
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const { data, isLoading } = useGeneralSearchQuery(
    debouncedSearchTerm,
    sortBy,
  );

  const formattedResults = useMemo(() => {
    if (!data) return { all: [] };

    const transformData = (
      responseItem: SearchResponseItem,
      type: SearchTypeEnum,
    ) =>
      responseItem.data.map((item: any) => ({
        ...item,
        searchType: type,
      }));

    const isAllOrChannels =
      !searchTypes.length || searchTypes.includes(SearchTypeEnum.CHAT);
    const isAllOrTodos =
      !searchTypes.length || searchTypes.includes(SearchTypeEnum.TODOS);
    const isAllOrDocs =
      !searchTypes.length || searchTypes.includes(SearchTypeEnum.DOCS);
    const isAllOrDrive =
      !searchTypes.length || searchTypes.includes(SearchTypeEnum.DRIVE);
    // const isAllOrBoard = !searchTypes.length || searchTypes.includes(SearchTypeEnum.BOARD);
    // const isAllOrMembers = !searchTypes.length || searchTypes.includes(SearchTypeEnum.MEMBERS);

    return data.reduce(
      (acc: MappedSearchResult, item: any) => {
        switch (item.type) {
          case 'channel':
          case 'channelMessage':
          case 'gathering':
          case 'meeting':
            if (isAllOrChannels) {
              const transformedData = transformData(item, SearchTypeEnum.CHAT);

              acc.channels = [...(acc.channels || []), ...transformedData];
              acc.all = [...acc.all, ...transformedData];
            }
            break;
          case 'todo':
          case 'todoItem':
            if (isAllOrTodos) {
              const transformedData = transformData(item, SearchTypeEnum.TODOS);

              acc.todos = [...(acc.todos || []), ...transformedData];
              acc.all = [...acc.all, ...transformedData];
            }
            break;
          case 'doc':
            if (isAllOrDocs) {
              const transformedData = transformData(item, SearchTypeEnum.DOCS);

              acc.docs = [...(acc.docs || []), ...transformedData];
              acc.all = [...acc.all, ...transformedData];
            }
            break;
          case 'driveContent':
            if (isAllOrDrive) {
              const transformedData = transformData(item, SearchTypeEnum.DRIVE);

              acc.drive = [...(acc.drive || []), ...transformedData];
              acc.all = [...acc.all, ...transformedData];
            }
            break;
          // case 'board':
          // case 'task':
          //   if (isAllOrBoard) {
          //     const transformedData = transformData(item, SearchTypeEnum.BOARD);

          //     acc.board = [...(acc.board || []), ...transformedData];
          //     acc.all = [...acc.all, ...transformedData];
          //   }
          //   break;
          // case 'members':
          //   if (isAllOrMembers) {
          //     const transformedData = transformData(item, SearchTypeEnum.MEMBERS);

          //     acc.members = [...(acc.members || []), ...transformedData];
          //     acc.all = [...acc.all, ...transformedData];
          //   }
          //   break;
          default:
            break;
        }

        return acc;
      },
      { all: [] },
    );
  }, [data, searchTypes]);

  return {
    searchData: isFlat ? formattedResults.all : formattedResults,
    isLoading,
    // refetch,
  };
};
